import 'react-app-polyfill/ie11'
import '@apiEnabler/api-enabler-common/lib/public-path'

import '@zambezi/css-helpers/css/helpers.css'
import '@apiEnabler/ob-common/lib/assets/common.css'
import '@apiEnabler/ob-common/lib/assets/responsive.css'
import '@apiEnabler/ob-common/lib/assets/brand.css'
import '@apiEnabler/ob-common/lib/assets/legacyThemeCompatibility.css'
import './app.css'
import './bob-theme.css'

import 'core-js/es/array'
import 'core-js/es/map'
import 'core-js/es/number'
import 'core-js/es/object'
import 'core-js/es/set'
import 'core-js/es/string'

import 'intersection-observer'

import '@apiEnabler/ob-common/lib/icons'
import { loadBrandAssets } from './brand'

import render$ from './view'
import store$ from './store'

loadBrandAssets()

IntersectionObserver.prototype.POLL_INTERVAL = 1000

store$.subscribe(render$)
